import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

import { SplashService } from '../services/splash/splash.service';
import { environment } from 'src/environments/environment';
import packageJson from 'package.json';

export const httpRequestInterceptor: HttpInterceptorFn = (req, next) => {
  const splashService = inject(SplashService);

  const version = packageJson.version;
  const headersConfig = {
    'app-version': version,
    origen: globalThis.location.origin,
  };

  const isAwaitHide = req.headers.get('await-loader');
  const isOnboardingStatus = req.url.includes('status-onboarding');

  if (!isOnboardingStatus) {
    splashService.showSplashRequest();
  }

  const clonedReq = req.clone({
    ...(environment.production && { setHeaders: headersConfig }),
  });

  return next(clonedReq).pipe(
    finalize(() => {
      if (!isAwaitHide) {
        splashService.hideSplashRequest();
      }
    }),
  );
};
